import {
  mapGetters,
} from 'vuex';

export default {
  name: 'SlotPickerMobile',
  components: {},
  props: {
    date: null,
    isActive: false,
    availableSlots: {
      type: Object,
      default: undefined,
    },
  },
  data: () => ({}),
  computed: {
    ...mapGetters('appointment', {
      errorSlot: 'getErrorSlot',
    }),
  },
  methods: {
    closeSlotsPicker() {
      this.$emit('on-close-slots-picker');
    },
    clickedOnSlot(availableSlot) {
      if (true) {
        this.$emit('on-close-slots-picker', availableSlot);
      }
    },
  },
};
